import script from "./LoginLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoginLayout.vue?vue&type=script&lang=ts&setup=true"

import "./LoginLayout.vue?vue&type=style&index=0&id=1d23b300&lang=css"

const __exports__ = script;

export default __exports__